import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { TranslateFunction, useI18N } from '@tm/client-form/src/hooks/useI18n'
import { SkipButtonState, skipFieldNames } from './useSkipButton'

export type SkipButtonProps = SkipButtonState

const getButtonText = (name: string, t: TranslateFunction) => {
  switch (name) {
    case 'noVideoRecord':
      return t('review.noVideoRecord')
    case 'noNegativeContact':
      return t('contactInfo.noContactInfo')
    case 'givePublicReviewInstead':
      return t('contactInfo.givePublicReviewInstead')
  }

  return t('review.noPublicConsent')
}

export function SkipButton(props: SkipButtonProps) {
  const { skipFields, handleSkipClick } = props
  const { t } = useI18N()
  const theme = useTheme()

  if (!skipFields?.length) return null
  const sortedSkipFields = skipFields.sort((a, b) => {
    const order = skipFieldNames
    return order.indexOf(a.name as typeof order[number]) - order.indexOf(b.name as typeof order[number])
  })
  return (
    <Stack justifyContent="center" alignItems="center" direction="row">
      {sortedSkipFields.map(skipField => {
        return (
          <Button
            key={skipField.name}
            variant="text"
            onClick={() => handleSkipClick(skipField.name)}
            sx={{
              ...theme.typography.body2,
              textDecoration: 'underline',
              color: 'text.secondary',
            }}>
            {getButtonText(skipField.name, t)}
          </Button>
        )
      })}
    </Stack>
  )
}
